import { BaseService } from './core/BaseService';
import { Workflow } from '../types';

class WorkflowApiService extends BaseService {
  async listWorkflows(): Promise<any[]> {
    return this.get<any[]>('/api/workflows');
  }

  async saveWorkflow(workflow: Omit<Workflow, 'id'>): Promise<Workflow> {
    return this.post<Workflow>('/api/workflows', workflow);
  }

  async uploadWorkflow(formData: FormData): Promise<any> {
    return this.upload<any>('/api/workflows', formData);
  }

  async deleteWorkflow(workflowId: string): Promise<void> {
    await this.delete(`/api/workflows/${workflowId}`);
  }
}

export const workflowApi = new WorkflowApiService();
